import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enGB from './locales/en-GB/common.json';
import enUS from './locales/en-US/common.json';
import enAU from './locales/en-AU/common.json';
import enCA from './locales/en-CA/common.json';
import frCA from './locales/fr-CA/common.json';
import frFR from './locales/fr-FR/common.json';
import deDE from './locales/de-DE/common.json';
import esES from './locales/es-ES/common.json';
import itIT from './locales/it-IT/common.json';
import nlNL from './locales/nl-NL/common.json';

// Merge helpers — en-US/AU/CA start from en-GB then override
function merge(base, overrides) {
  const result = JSON.parse(JSON.stringify(base));
  function deepMerge(target, source) {
    for (const key of Object.keys(source)) {
      if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
        target[key] = target[key] || {};
        deepMerge(target[key], source[key]);
      } else {
        target[key] = source[key];
      }
    }
  }
  deepMerge(result, overrides);
  return result;
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'en-GB': { common: enGB },
      'en-US': { common: merge(enGB, enUS) },
      'en-AU': { common: merge(enGB, enAU) },
      'en-CA': { common: merge(enGB, enCA) },
      'fr-FR': { common: frFR },
      'fr-CA': { common: merge(frFR, frCA) },
      'de-DE': { common: deDE },
      'es-ES': { common: esES },
      'it-IT': { common: itIT },
      'nl-NL': { common: nlNL },
    },
    lng: 'en-GB',
    fallbackLng: {
      'en-US': ['en-GB'],
      'en-AU': ['en-GB'],
      'en-CA': ['en-GB'],
      'fr-CA': ['fr-FR', 'en-GB'],
      default: ['en-GB'],
    },
    ns: ['common'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'aidey_language',
      caches: ['localStorage'],
    },
  });

export default i18n;

/**
 * Change the active language, persist it to localStorage.
 * Also called from CurrentUserContext when the user profile loads.
 */
export function applyLanguage(lang) {
  if (!lang) return;
  const supported = ['en-GB', 'en-US', 'en-AU', 'en-CA', 'fr-FR', 'fr-CA', 'de-DE', 'es-ES', 'it-IT', 'nl-NL'];
  const resolved = supported.includes(lang) ? lang : 'en-GB';
  i18n.changeLanguage(resolved);
  localStorage.setItem('aidey_language', resolved);
}
